import {
  AfterContentInit,
  AfterViewInit,
  Component, ContentChild,
  ContentChildren,
  ElementRef,
  Input,
  OnInit,
  ViewChild, ViewChildren
} from '@angular/core';
import {NavController} from "@ionic/angular";
import {CommonService} from "../../service/common.service";

@Component({
  selector: 'app-title-section',
  templateUrl: './title-section.component.html',
  styleUrls: ['./title-section.component.scss'],
})
export class TitleSectionComponent implements OnInit, AfterContentInit {

  @Input() title: string;
  @Input() subTitle: string;
  @Input() navigateTo: string;

  @ViewChild('contentBoxRef') contentBoxRef!: ElementRef;

  constructor(private navCtrl: NavController,
              private commonService: CommonService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.contentBoxRef.nativeElement.firstElementChild.classList.add('horizontal-scroll');
  }

  ngAfterContentInit(): void {
    //this.contentBoxRef.nativeElement.classList.add('horizontal-scroll');
  }

  onNavigateTo() {

    if (!this.navigateTo) {
      return;
    }

    if (this.navigateTo?.indexOf('https://') != -1) {
      this.commonService.onOpenLinkBrowser(this.navigateTo);
    } else {
      this.navCtrl.navigateForward(this.navigateTo);
    }

  }

}
